import { IApiTestParams } from "../shared/types/testing.types";
import {
  ADMIN_OUTAGES_ENDPOINT,
  LOOKUPS_ENDPOINT,
  OUTAGES_ENDPOINT,
  SEARCH_OUTAGES_ENDPOINT,
  VERSION_ENDPOINT,
} from "./constants/urls.constants";

export enum EApiTypes {
  LOOKUPS = "lookups",
  OUTAGES = "outages",
  SEARCH_OUTAGES = "outages/search",
  ADMIN_OUTAGES = "outages/admin",
  VERSION = "version",
}

export enum EEnvironments {
  DEV = "dev",
  QA = "qa",
  PROD = "prod",
}

const getEndpoint = (apiName: string, params?: IApiTestParams): string => {
  let endpoint;
  switch (apiName) {
    case EApiTypes.LOOKUPS:
      endpoint = LOOKUPS_ENDPOINT;
      break;
    case EApiTypes.OUTAGES:
      endpoint = OUTAGES_ENDPOINT;
      break;
    case EApiTypes.SEARCH_OUTAGES:
      endpoint = SEARCH_OUTAGES_ENDPOINT;
      break;
    case EApiTypes.ADMIN_OUTAGES:
      endpoint = ADMIN_OUTAGES_ENDPOINT;
      break;
    case EApiTypes.VERSION:
      endpoint = VERSION_ENDPOINT;
      break;
    default:
      endpoint = "/";
      break;
  }

  if (params) {
    if (params.testHttpError) {
      return `${endpoint}?testHttpError=${params.testHttpError}`;
    } else if (params.id) {
      return `${endpoint}/${params.id}`;
    } else {
      return endpoint;
    }
  } else {
    return endpoint;
  }
};

export default { getEndpoint };
